import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AppSettingsService } from "../app-settings-service/app-settings.service";
import { AuthService } from "../auth";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { AnalyticsService } from "../analytics-service/analytics.service";

export const authGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const iframeMessagesService = inject(IframeMessagesService);
    const router = inject(Router);
    const analyticsService = inject(AnalyticsService);
    const appSettingsService = inject(AppSettingsService);

    if (!auth.loggedIn()) {
        try {
            await auth.getLoginWithSession();
        } catch (exception) {
            console.error("Login failure:", exception);
            return router.createUrlTree(["accessdenied"]);
        }
    }

    analyticsService.track("User login - Internal - Web-app", {
        UserID: auth.currentUser.sub,
    });

    if (auth.currentUser.firm_id) {
        if (
            !(
                auth.currentUser.ifirm_url === iframeMessagesService.messagesOrigin ||
                (appSettingsService.appSettings.LocalVM_URL && auth.currentUser.ifirm_url === appSettingsService.appSettings.LocalVM_URL)
            )
        ) {
            analyticsService.track("User login - Token mismatch", { TokenUrl: auth.currentUser.ifirm_url });
            return router.createUrlTree(["accessdenied"]);
        } else {
            return true;
        }
    } else {
        auth.logout(true);
        return router.createUrlTree(["accessdenied"]);
    }
};
